import {
  Salaries as SalariesIcon,
  Equipment as EquipmentIcon,
  Travel as TravelIcon,
  Operating as OperatingIcon,
  SuppliesAndMaterials as SuppliesAndMaterialsIcon,
  Other as OtherIcon,
  Overview as OverviewIcon,
} from "../../Components/Icon";

import Personnel from "../../Pages/ProjectFinancing/Personnel";
import Equipment from "../../Pages/ProjectFinancing/Equipment";
import Travel from "../../Pages/ProjectFinancing/Travel";
import Services from "../../Pages/ProjectFinancing/Services";
import SuppliesMaterialServices from "../../Pages/ProjectFinancing/SuppliesMaterialServices";
import Other from "../../Pages/ProjectFinancing/Other";
import Overview from "../../Pages/ProjectFinancing/Overview";

const navigation = () => ({
  header: "Budget",
  links: [
    {
      text: "Personnel",
      icon: SalariesIcon,
      route: "personnel",
      component: Personnel,
      preProposal: true,
    },
    {
      text: "Travel",
      icon: TravelIcon,
      route: "travel",
      component: Travel,
      preProposal: true,
    },
    {
      text: "Equipment",
      icon: EquipmentIcon,
      route: "equipment",
      component: Equipment,
      preProposal: true,
    },
    {
      text: "Supplies & Materials",
      icon: SuppliesAndMaterialsIcon,
      route: "suppliesmaterialsservices",
      component: SuppliesMaterialServices,
      preProposal: true,
    },
    {
      text: "Services",
      icon: OperatingIcon,
      route: "services",
      component: Services,
      preProposal: true,
    },
    {
      text: "Other",
      icon: OtherIcon,
      route: "other",
      component: Other,
      preProposal: true,
    },
    {
      text: "Overview",
      icon: OverviewIcon,
      route: "overview",
      component: Overview,
      preProposal: true,
    },
  ],
});

export default navigation;
